module.exports = __webpack_public_path__ + "static/media/veganSelected.fceae8e1.svg";